export const NAME = "Rolando Eccleston";
export const ROLE = "UX Designer | Operations Leader | Community Builder";
export const TAGLINE = "Building digital experiences, systems, and organizations that move people forward.";

export const STATS = [
  "17 Years in Education",
  "23 Years Coaching",
  "1,500+ Athlete Events Managed",
  "6 Products Designed",
  "3 Organizations Built",
];

export const LANES = [
  { n: "01", key: "products", title: "Digital Products & Apps", route: "/products",
    desc: "End-to-end digital product work that turns complex needs into clear, useful, high-performing experiences." },
  { n: "02", key: "ux", title: "UX Design & Case Studies", route: "/ux",
    desc: "Deep, structured case studies — a build, a solve, a change, an anchor, and a system." },
  { n: "03", key: "operations", title: "Operations & Event Leadership", route: "/operations",
    desc: "Large-scale event operations, logistics, and process design at serious scale." },
  { n: "04", key: "coaching", title: "Coaching & Community Leadership", route: "/coaching",
    desc: "Coaching, mentorship, and leadership across athletic and civic communities." },
  { n: "05", key: "development", title: "Professional Development", route: "/development",
    desc: "Continuous learning — UX, cybersecurity, project management, and digital marketing." },
];

export const LANE_META = {
  products: {
    title: "Digital Products & Apps",
    intro: "Products and websites, built and shipped. A gallery of interfaces designed to be legible, fast, and quietly confident.",
    center: "Digital Products",
  },
  operations: {
    title: "Operations & Event Leadership",
    intro: "Large-scale event management, process improvement, and the systems that keep hundreds of moving parts in sync.",
    center: "Operations",
  },
  coaching: {
    title: "Coaching & Community Leadership",
    intro: "Coaching, mentorship, and community leadership across athletic, Masonic, and Elks organizations.",
    center: "Community",
  },
  development: {
    title: "Professional Development",
    intro: "Continuous learning — UX certification, cybersecurity, project management, and digital marketing.",
    center: "Growth",
  },
};
